type Props = {
  title: string;
};

export function TagComponent(props: Props) {
  return (
    <div className="px-2 bg-gray-200 rounded text-nowrap">{props.title}</div>
  );
}
